module.exports = __webpack_public_path__ + "img/star.bc14ed98.svg";